import { useMemo } from 'react';
import { useAppDispatch } from './useAppDispatch';
import { bindActionCreators } from '@reduxjs/toolkit';
import { allActionCreators } from '@/store/actionCreators';

export const useActions = () => {
    const dispatch = useAppDispatch();
    // Стабильная ссылка: dispatch стабилен у React-Redux, allActionCreators — модульный singleton.
    // Без useMemo каждый рендер давал новые функции → ломал зависимости useCallback/useEffect.
    return useMemo(() => bindActionCreators(allActionCreators, dispatch), [dispatch]);
};
